// extracted by mini-css-extract-plugin
module.exports = {"riskCard":"RiskSelection_riskCard__1NspC","riskCardLoader":"RiskSelection_riskCardLoader__2F40i"};